// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1X0-O","name":"Header_name__3wDV1","birthday":"Header_birthday__1VLAW","skeleton":"Header_skeleton__3Pps0"};